import React from 'react';

import Hero from '../components/hero';
import Opener from '../components/speech-bubble-opener';
import Stories from '../components/stories';
import Laptop from '../components/laptop-cta';

const AboutTemplate = () => {
	return (
		<div>
			<Hero
				img="/img/Stories_Masthead.svg"
				alt="People telling stories illustration"
				mobileImg="/img/stories-mobile.svg"
			/>
			<Opener
				bg="/img/Green_Blob.svg"
				content="We all have a story. Through sharing our experiences, we hope to encourage others to openly communicate about their challenges, and their triumphs. Read below and learn more about mental health challenges and focuses in your community, and ways to help or seek help."
			/>
			<Stories />
			<Laptop img="/img/ComputerWoman.svg" />
		</div>
	);
};

export default AboutTemplate;
